module.exports = __webpack_public_path__ + "img/052CF049EB71228A9A7EA5522BA73277.394b17bf.jpg";